import { Address, beginCell, toNano } from '@ton/core'
import type { SendTransactionRequest } from '@tonconnect/ui-react'
import { useTonConnectUI } from '@tonconnect/ui-react'
import { ECurrency } from '../types/enums'

export const useTransaction = () => {
  const [tonConnectUi] = useTonConnectUI()

  const sendTransaction = (data: {
    amount: string
    address: string
    id: string
    currency: ECurrency
    smartContractAddress?: string | undefined
  }) => {
    const comment = beginCell()
      .storeUint(0, 32)
      .storeStringTail(data.id)
      .endCell()
    const message: SendTransactionRequest['messages'][number] =
      data.currency === ECurrency.TON
        ? ({
            address: data.address,
            amount: String(data.amount),
            payload: comment.toBoc().toString('base64'),
          } as const)
        : {
            address: data.smartContractAddress!,
            amount: '0', // No TON required for message
            payload: beginCell()
              .storeUint(0xf8a7ea5, 32) // Jetton transfer op code
              .storeUint(0, 64)
              .storeCoins(BigInt(data.amount))
              .storeAddress(Address.parse(data.address)) // destination:MsgAddress
              .storeAddress(Address.parse(data.address)) // response_destination:MsgAddress (defailt = null)
              // .storeBit(0)
              // .storeMaybeRef(null)
              .storeUint(0, 1)
              .storeCoins(toNano('0.03')) // forward_ton_amount as a gas fee
              .storeBit(1)
              .storeRef(comment)
              .endCell()
              .toBoc()
              .toString('base64'),
          }
    return tonConnectUi.sendTransaction({
      validUntil: Math.floor(Date.now() / 1000 + 300), // 5 minutes
      messages: [message],
    })
  }

  return {
    sendTransaction,
  }
}
